import { render } from "./CreateDependencia.vue?vue&type=template&id=be3b25d6&scoped=true"
import script from "./CreateDependencia.vue?vue&type=script&lang=js"
export * from "./CreateDependencia.vue?vue&type=script&lang=js"

import "./CreateDependencia.vue?vue&type=style&index=0&id=be3b25d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be3b25d6"]])

export default __exports__